"use client";
import { jsxs as i, jsx as c } from "react/jsx-runtime";
const e = ({
  title: h,
  titleId: l,
  desc: s,
  descId: a,
  ...r
}) => /* @__PURE__ */ i(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -8 512 512",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    "aria-labelledby": l,
    "aria-describedby": a,
    ...r,
    children: [
      s ? /* @__PURE__ */ c("desc", { id: a, children: s }) : null,
      h ? /* @__PURE__ */ c("title", { id: l, children: h }) : null,
      /* @__PURE__ */ c(
        "path",
        {
          fill: "#58abfb",
          d: "M248 432h16c8.836 0 16 7.164 16 16v24c0 8.836-7.164 16-16 16h-16c-8.836 0-16-7.164-16-16v-24c0-8.836 7.164-16 16-16m0 0"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          fill: "#fff",
          d: "M504 80v272c0 17.6719-14.3281 32-32 32H40c-17.6719 0-32-14.3281-32-32V80c0-17.6719 14.3281-32 32-32h48V16c0-4.418 3.582-8 8-8h320c4.418 0 8 3.582 8 8v32h48c17.6719 0 32 14.3281 32 32m0 0"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          fill: "#58abfb",
          d: "M424 16c0-4.418-3.582-8-8-8H96c-4.418 0-8 3.582-8 8v32h336zM168 168c0 26.5078-21.4922 48-48 48s-48-21.4922-48-48 21.4922-48 48-48 48 21.4922 48 48M168 288c0 26.5078-21.4922 48-48 48s-48-21.4922-48-48 21.4922-48 48-48 48 21.4922 48 48m0 0"
        }
      ),
      /* @__PURE__ */ i("g", { fill: "#107be8", children: [
        /* @__PURE__ */ c("path", { d: "M472 40h-40V16c0-8.836-7.164-16-16-16H96c-8.836 0-16 7.164-16 16v24H40C17.918 40.0273.0273 57.918 0 80v272c.0273 22.082 17.918 39.9727 40 40h208v32c-13.254 0-24 10.746-24 24v24c0 13.254 10.746 24 24 24h16c13.254 0 24-10.746 24-24v-24c0-13.254-10.746-24-24-24v-32h208c22.082-.0273 39.9727-17.918 40-40V80c-.0273-22.082-17.918-39.9727-40-40M272 448v24c0 4.418-3.582 8-8 8h-16c-4.418 0-8-3.582-8-8v-24c0-4.418 3.582-8 8-8h16c4.418 0 8 3.582 8 8m224-96c0 13.254-10.746 24-24 24H40c-13.254 0-24-10.746-24-24V80c0-13.254 10.746-24 24-24h48c4.418 0 8-3.582 8-8V16h320v32c0 4.418 3.582 8 8 8h48c13.254 0 24 10.746 24 24zm0 0" }),
        /* @__PURE__ */ c("path", { d: "M128 56h256c4.418 0 8-3.582 8-8s-3.582-8-8-8H128c-4.418 0-8 3.582-8 8s3.582 8 8 8M162.3438 130.3438 120 172.6875l-10.3437-10.3437c-3.1407-3.0313-8.129-2.9883-11.2149.0976s-3.1289 8.0742-.0977 11.2149l16 16c3.125 3.121 8.1876 3.121 11.3126 0l48-48c3.0312-3.1407 2.9882-8.129-.0977-11.2149s-8.0742-3.1289-11.2149-.0976M162.3438 242.3438 120 284.6875l-10.3437-10.3437c-3.1407-3.0313-8.129-2.9883-11.2149.0976s-3.1289 8.0742-.0977 11.2148l16 16c3.125 3.1211 8.1876 3.1211 11.3126 0l48-48c3.0312-3.1406 2.9882-8.1289-.0977-11.2148s-8.0742-3.1289-11.2149-.0976M224 136c-4.418 0-8 3.582-8 8s3.582 8 8 8h24c4.418 0 8-3.582 8-8s-3.582-8-8-8zM280 136c-4.418 0-8 3.582-8 8s3.582 8 8 8h24c4.418 0 8-3.582 8-8s-3.582-8-8-8zM408 168H224c-4.418 0-8 3.582-8 8s3.582 8 8 8h184c4.418 0 8-3.582 8-8s-3.582-8-8-8M224 264h24c4.418 0 8-3.582 8-8s-3.582-8-8-8h-24c-4.418 0-8 3.582-8 8s3.582 8 8 8M304 264c4.418 0 8-3.582 8-8s-3.582-8-8-8h-24c-4.418 0-8 3.582-8 8s3.582 8 8 8zM408 280H224c-4.418 0-8 3.582-8 8s3.582 8 8 8h184c4.418 0 8-3.582 8-8s-3.582-8-8-8m0 0" })
      ] })
    ]
  }
);
export {
  e as default
};
